import popupStyles from "./generalSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { tWithKeyAttr as t } from "../../../i18nHelper";


function GeneralSuccessPopup({ onClose, infoText }: IPopupWithoutProps & { infoText?: string | null }) {
  return (
    <article className={popupStyles.popup} data-testid="success-popup">
      <h2 className={popupStyles.popup__title}>{t('DATA_UPDATED_SUCCESSFULLY')}</h2>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      {infoText && (<p className={popupStyles.popup__text}>
        {infoText}
      </p>)}
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        data-testid="success-popup-ok-button"
        onClick={onClose}
      >{t('CONFIRM')}</button>
    </article>
  );
}

export default GeneralSuccessPopup;
